// Function to update slider position
const updateSliderPosition = (slider, position) => {
	const sliderImg = slider.querySelector('.before-after-img')
	const sliderLine = slider.querySelector('.before-after-line')
	const sliderBtn = slider.querySelector('.before-after-button')

	sliderImg.style.width = `${position}%`
	sliderLine.style.left = `${position}%`
	sliderBtn.style.left = `${position}%`
}

// Loop through each slider element
document.querySelectorAll('.before-after-slider').forEach(slider => {
	let isDragging = false

	const handleTouchMove = e => {
		if (isDragging) {
			const touchPosition = e.touches[0].clientX - slider.getBoundingClientRect().left
			const newPosition = (touchPosition / slider.offsetWidth) * 100
			updateSliderPosition(slider, newPosition)
		}
	}

	// Event listeners for input (mouse) and touch (mobile)
	slider.addEventListener('input', e => {
		updateSliderPosition(slider, e.target.value)
	})

	slider.addEventListener('touchstart', e => {
		isDragging = true
		const touchPosition = e.touches[0].clientX - slider.getBoundingClientRect().left
		const newPosition = (touchPosition / slider.offsetWidth) * 100
		updateSliderPosition(slider, newPosition)
	})

	slider.addEventListener('touchmove', handleTouchMove)

	slider.addEventListener('touchend', () => {
		isDragging = false
	})
})

// ELement do skopiowania poniżej, trzeba dostosować style i podmienić zdjęcia

// <div class="before-after-slider grid place-content-center relative overflow-hidden">
//       <div class="">
//         <img src="<?php echo get_stylesheet_directory_uri() . '/images/wykres-zwiekszenie-seo.svg' ?>" class=" w-full h-full object-cover object-left" alt="">
//         <img src="<?php echo get_stylesheet_directory_uri() . '/images/wykres-zwiekszenie-seo.svg' ?>" class=" h-full object-cover object-left absolute inset-0 w-1/2 grayscale before-after-img" alt="">
//       </div>
//       <input type="range" min="0" max="100" value="50" aria-label="Percentage of before photo shown" class="before-after absolute inset-0 cursor-pointer opacity-0 w-full h-full group" />
//       <div class="before-after-line absolute inset-0 w-1 h-full bg-pearlyPurple left-1/2 -translate-x-1/2 pointer-events-none shadow-2xl" aria-hidden="true"></div>
//       <div class="before-after-button group-focus-visible:outline group-focus-visible:outline-4 group-focus-visible:outline-black group-focus-visible:outline-offset-2 absolute bg-pearlyPurple text-black p-2 rounded-full grid place-items-center top-1/2
//        left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none shadow-2xl " aria-hidden="true">
//         <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#fff" viewBox="0 0 256 256">
//           <rect width="256" height="256" fill="none"></rect>
//           <line x1="128" y1="40" x2="128" y2="216" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>
//           <line x1="96" y1="128" x2="16" y2="128" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>
//           <polyline points="48 160 16 128 48 96" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
//           <line x1="160" y1="128" x2="240" y2="128" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>
//           <polyline points="208 96 240 128 208 160" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline>
//         </svg>
//       </div>
//     </div>
